/* HDD Sport · portada (v2)
   Kimonos en 3D: el motor y los modelos empiezan a descargarse en cuanto se puede; si hay entrada de
   flores, los kimonos esperan a que termine («hdd:intro-done») y entonces aparecen girando.
   En móvil se usan modelos con texturas más ligeras.
   Si falta WebGL, la persona pide menos movimiento o ahorra datos, se quedan las fotos fijas. */
(() => {
  const doc = document.documentElement;
  const hero = document.querySelector('[data-hs-hero]');
  const introDone = () => !!window.__hddIntroDone;
  const showKimonos = () => doc.classList.remove('hs-wait-kimonos');
  // sin héroe o sin entrada: nada que esperar
  if (!hero) { showKimonos(); return; }

  const dataEl = hero.querySelector('[data-hs-models]');
  const canvas = hero.querySelector('[data-hs-canvas]');
  let models = null;
  try { models = dataEl ? JSON.parse(dataEl.textContent) : null; } catch (err) { console.warn('[HDD 3D] Datos de modelos ilegibles:', err); }

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const conn = navigator.connection;
  const saveData = !!(conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')));
  const small = window.matchMedia('(max-width: 749px)').matches;
  const hasGL = (() => {
    try { const c = document.createElement('canvas'); return !!(c.getContext('webgl2') || c.getContext('webgl')); } catch (err) { return false; }
  })();
  const can3d = !!(canvas && hero.dataset.stage && Array.isArray(models) && models.length && models.every((m) => m && m.url) && !reduce && !saveData && hasGL);

  if (can3d) {
    models = models.map((m) => ({ url: small && m.url_m ? m.url_m : m.url, dark: !!m.dark }));
    // descarga anticipada (va a la caché del navegador; el cargador 3D la reutiliza)
    models.forEach((m) => { try { fetch(m.url, { mode: 'cors', credentials: 'omit' }).catch(() => {}); } catch (e) { /* nada */ } });
  }
  const modPromise = can3d ? import(hero.dataset.stage) : null;
  if (modPromise) modPromise.catch(() => {});

  let mounted = false;
  const mount3d = (wait) => {
    if (!can3d || mounted) return Promise.resolve(null);
    mounted = true;
    return modPromise
      .then((mod) => mod.mount(hero, canvas, models, { wait }))
      .then((stage) => { hero.classList.add('is-3d'); return stage; })
      .catch((err) => { console.warn('[HDD 3D] No se pudo cargar el 3D; se muestran las fotos.', err); return null; });
  };

  const onIntroDone = () => {
    if (!can3d) { showKimonos(); return; }
    // si el 3D llega a tiempo, los kimonos entran girando; si no, entran las fotos y luego pasan a 3D
    let shown = false;
    const fallback = setTimeout(() => { shown = true; showKimonos(); }, 700);
    mount3d(true).then((stage) => {
      if (!stage) { clearTimeout(fallback); showKimonos(); return; }
      if (!shown) { clearTimeout(fallback); showKimonos(); stage.reveal(); }
      else stage.showNow();          // las fotos ya estaban: paso directo a 3D, sin saltos
    });
  };

  if (doc.classList.contains('hs-wait-kimonos') && !introDone()) {
    let fired = false;
    const once = () => { if (!fired) { fired = true; onIntroDone(); } };
    window.addEventListener('hdd:intro-done', once, { once: true });
    if (!window.__HDD_LYCORIS_FIXED_DT) setTimeout(once, 9500);          // seguro: si la entrada no llega a avisar, los kimonos salen igual
  } else {
    showKimonos();
    if (can3d) {
      const go = () => mount3d(false);
      if (document.readyState === 'complete') go();
      else window.addEventListener('load', go, { once: true });
    }
  }
})();
